var swiper8 = new Swiper(".cryoProducts", {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    autoplay: true,
    navigation: {
        nextEl: ".infocard-next",
        prevEl: ".infocard-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + "</span>";
        },
    },
    breakpoints: {
      280: {
        slidesPerView: 1.5,
        spaceBetween: 30,
      },
      720: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
});


//Product modal scroll
let lastScrollY = window.scrollY;

window.addEventListener('scroll', function () {
  const productModal = document.querySelector('.product-modal-scroll');
  const currentScrollY = window.scrollY || window.pageYOffset;

  if (currentScrollY > 550 && currentScrollY > lastScrollY) {
    productModal.classList.add('visible');
  } else {
    productModal.classList.remove('visible');
  }

  lastScrollY = currentScrollY;
});
